/* Component Dependencies */
var titleSubtitleTextTemplate = require('templates/titleSubtitleText.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'titleSubtitleText',
  template: {
    'titleSubtitleText': titleSubtitleTextTemplate
  }
});
